// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1z4H_","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2aBq5"};